'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * Logs all the actions and associated state mutations
 * @param {MiddlewareAPI} api Middleware API
 * @param {Dispatch} next Next dispach function
 * @param {Action} action The action being dispached
 * @returns {void}
 */
var reduxLoggerMiddleware = function reduxLoggerMiddleware(api) {
  return function (next) {
    return function (action) {
      var currentState = api.getState();

      var _currentState$get = currentState.get('tunnel'),
          log = _currentState$get.log;

      log.info('Previous State: ', currentState);
      log.info('Action: ', action);
      next(action);
      log.info('Next State: ', api.getState());
    };
  };
};
exports.default = reduxLoggerMiddleware;
//# sourceMappingURL=reduxLoggerMiddleware.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-logger-middleware/dist/main/reduxLoggerMiddleware.js
// module id = 528
// module chunks = 0